function SketchButton({ children, onClick, disabled, type = 'button' }) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        transition: 'transform 0.1s ease',
      }}
      onPointerDown={(e) => {
        if (!disabled) e.currentTarget.style.transform = 'scale(0.95)';
      }}
      onPointerUp={(e) => {
        if (!disabled) e.currentTarget.style.transform = '';
      }}
      onPointerLeave={(e) => {
        e.currentTarget.style.transform = '';
      }}
    >
      {/* Left cap */}
      <img
        src="/button_left.png"
        alt=""
        style={{
          display: 'block',
          height: '3.75rem',
          width: 'auto',
          marginTop: '-6px',
          pointerEvents: 'none',
        }}
      />
      {/* Right stretchy body */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '3.75rem',
          backgroundImage: 'url(/button_right.png)',
          backgroundSize: '100% 100%',
          backgroundRepeat: 'no-repeat',
          padding: '0 24px 0 8px',
          marginLeft: '-2px',
        }}
      >
        <span
          style={{
            color: 'white',
            fontSize: '1.6rem',
            fontWeight: 700,
            fontFamily: '"Pangolin", "Fredericka the Great", "Rock Salt", cursive',
            letterSpacing: '2px',
            textTransform: 'uppercase',
            whiteSpace: 'nowrap',
          }}
        >
          {children}
        </span>
      </div>
    </button>
  );
}

export default SketchButton;
